/**
 * El commit con el que se construyó esta versión del ERP.
 *
 * ## Para qué
 *
 * Quien prueba en dev tiene que poder anotar **qué versión probó**. Sin esto, ese dato
 * se rellenaba comparando horas de despliegue — o a ojo. Un commit supuesto en un
 * registro de pruebas es peor que un hueco, porque **parece un dato**.
 *
 * ## No se calcula aquí, y eso es el punto
 *
 * `VITE_RELEASE_SHA` la inyecta **Amplify en el BUILD**:
 * `VITE_RELEASE_SHA=$AWS_COMMIT_ID npm run build`, en el `build_spec` de
 * `verix-infra/modules/amplify/main.tf`. Vite la sustituye por su valor literal al
 * compilar, así que lo que llega al navegador es una cadena fija — no hay forma de que
 * el valor "derive" en ejecución.
 *
 * 🔑 **Ya existía**, puesta para etiquetar las releases de Sentry
 * (`lib/sentryInit.js`). Aquí solo se PINTA. Por eso esto no necesita ningún cambio de
 * infraestructura ni de los workflows.
 *
 * ## Sin la variable no se pinta NADA
 *
 * Un build local no la tiene. Mostrar un hueco —o un «desconocido»— invita a que
 * alguien lo anote igualmente. No mostrar nada dice la verdad: aquí no consta.
 */
export default function CommitDeLaBuild({ oculto = false }) {
  const sha = import.meta.env.VITE_RELEASE_SHA;
  if (oculto || !sha) return null;

  return (
    <div
      className="px-2 pt-1 text-[10px] leading-tight text-sidebar-foreground/40 select-text"
      // El hash entero, para poder copiarlo al registro de pruebas sin recortar.
      title={String(sha)}
      data-testid="commit-de-la-build"
    >
      versión {String(sha).slice(0, 7)}
    </div>
  );
}
